import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLookupData } from "../../../redux/slices/lookupSlice";
import { addNewUnit } from "../../../redux/slices/myAccount/unitSlice";
import { requestUnit } from "../../../redux/slices/myAccount/unitRequestSlice";
import { Box, IconButton } from "@mui/material";
import SelectDropdown from "../../SelectDropdown/SelectDropdown";
import ActionButton from "../../ReusableForm/ActionButton/ActionButton";
import UnitFormModal from "../../UnitFormModal/UnitFormModal";
import { FaPlus } from "react-icons/fa6";
import SuccessSnackbar from "../../SuccessSnackbar/SuccessSnackbar";
import { useLanguage } from "../../../context/LanguageContext/LanguageContext";
import { useFormik } from 'formik';
import { FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { fetchEquipments } from "../../../redux/slices/myAccount/equipmentsSlice";
import CircularProgress from '@mui/material/CircularProgress';

const AddUnit = ({ setFormData }) => {
    const { translations, language, direction } = useLanguage();
    const [openModal, setOpenModal] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [pendingUnits, setPendingUnits] = useState([]);
    const [isAddDisabled, setIsAddDisabled] = useState(false);
    const handleOpenUnit = () => {
        setOpenModal(true); // Open the modal when the button is clicked
    };
    // Close modal function
    const handleCloseUnit = () => {
        setOpenModal(false); // Close the modal
    };
    const handleBack = () => {

        navigate(-1); // This will go back to the previous page in the history stack
    };
    const t = translations;
    const { isLoggedIn, user, token } = useSelector(state => state.login);
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const { equipments, loading: pendingUnitRequest } = useSelector(state => state.equipments);
    const { success, loading: unitLoading, error: unitError } = useSelector((state) => state.unit);
    const { success: successUnitRequest, loading: UnitRequestLoading, error: UnitRequestError } = useSelector((state) => state.unitRequest); // Use unitRequest state
    const [status, setstatus] = useState(1);
    // Inside the AddUnit component
    const formik = useFormik({
        initialValues: {
            city: '',
            district: '',
            project: '',
            building: '',
            floor: '',
            unit: ''
        },
        // Add validation schema or validation function here if needed
        onSubmit: values => {

        },
    });
    // Fetch equipment data if needed
    useEffect(() => {
        if (isLoggedIn && token) {
            const params = {
                customerFk: user.id,
                status: 1
            };
            dispatch(fetchEquipments({ params, token, language }));
        }
    }, [dispatch, isLoggedIn, token, language, user, status]);

    useEffect(() => {
        if (equipments && equipments.message && equipments.message.data) {
            const unitsWithStatusOne = equipments.message.data.filter(
                (unit) => unit.status === 1
            );
            setPendingUnits(unitsWithStatusOne);

            // Disable buttons if there are pending units
            setIsAddDisabled(unitsWithStatusOne.length > 0);
        }
    }, [equipments]);
    const [newUnitAdded, setNewUnitAdded] = React.useState(false);
    const [newlyAddedUnitName, setNewlyAddedUnitName] = useState("");
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [snackbarMessage, setSnackbarMessage] = React.useState("");
    const { lookups, loading, error } = useSelector((state) => state.lookup);

    const fetchIfNotLoaded = (lookupNumber, parentId) => {
        dispatch(fetchLookupData({ lookupNumber, parentId, language, allowNotSelectedUnitsOnly: true }));
    };

    useEffect(() => {
        fetchIfNotLoaded(1, null); // Always fetch city
        if (formik.values.city) fetchIfNotLoaded(2, formik.values.city);
        if (formik.values.district) fetchIfNotLoaded(3, formik.values.district);
        if (formik.values.project) fetchIfNotLoaded(4, formik.values.project);
        if (formik.values.building) fetchIfNotLoaded(5, formik.values.building);
        if (formik.values.floor) fetchIfNotLoaded(6, formik.values.floor);
    }, [
        dispatch,
        formik.values.city,
        formik.values.district,
        formik.values.project,
        formik.values.building,
        formik.values.floor,
    ]);

    const handleClearUnit = () => {
        formik.setFieldValue("unit", "");
        setNewUnitAdded(false);
    };

    const handleFormSubmit = (newUnit) => {
        const unitData = {
            equipmentNameAr: newUnit.unitNameArabic,
            equipmentNameEn: newUnit.unitNameEnglish,
            descriptionAr: newUnit.descriptionArabic,
            descriptionEn: newUnit.descriptionEnglish,
            floorFk: formik.values.floor || 0,
            customerFk: user.id, // Assuming customerFk is fetched or passed as needed
        };
        setNewlyAddedUnitName(unitData);

    };
    // Handle the Request New Unit button click
    const handleRequestNewUnit = () => {
     
        if (formik.values.unit) {
            const selectedUnit = lookups[6]?.find(
                (unit) => unit.id === formik.values.unit
            ); // Fetch the selected unit name based on its value
            const unitName = selectedUnit ? selectedUnit.name : formik.values.unit; // Fallback to formik value if name not found
    
        
            dispatch(requestUnit({ customerFk: user.id, equipmentId: formik.values.unit, token }))
                .then((response) => {
                    if (response && response.payload.successtate === 200) {
                        setSnackbarMessage(t.unitadded.replace("{unitName}", unitName));
                        setOpenSnackbar(true);
                        setSnackbarSeverity('success');
                        setNewUnitAdded(false);
                        setNewlyAddedUnitName("");
                        formik.resetForm();
                        dispatch(fetchEquipments({ params: { customerFk: user.id, status: 1 }, token, language }));
                    } else {
                        setSnackbarMessage(`Error: ${response.payload.errormessage || 'Unknown error'}`);
                        setOpenSnackbar(true);
                        setSnackbarSeverity('error');
                    }
                })
                .catch((error) => {
                    setSnackbarMessage(`Error: ${error.message}`);
                    setOpenSnackbar(true);
                    setSnackbarSeverity('error');
                });
        } else if (newlyAddedUnitName) {
            dispatch(addNewUnit({ newlyAddedUnitName, token }))
                .then((response) => {
                    // Check if the response status is 200
                    if (response && response.payload.successtate === 200) {
                        handleCloseUnit();
                        setSnackbarMessage(t.unitadded.replace("{unitName}", newlyAddedUnitName.equipmentNameEn));
                        setOpenSnackbar(true);
                        setSnackbarSeverity('success'); // Set severity as success
                        // setNewUnitAdded(true);
                        formik.resetForm();
                        setNewlyAddedUnitName("");
                        dispatch(fetchEquipments({ params: { customerFk: user.id, status: 1 }, token, language }));
                    } else {
                        // Handle error or show appropriate message from response
                        setSnackbarMessage(`Error: ${response.payload.errormessage || 'Unknown error'}`);
                        setOpenSnackbar(true);
                        setSnackbarSeverity('error'); // Set severity as error
                    }
                })
                .catch((error) => {
                    setSnackbarMessage(`Error: ${error.message}`);
                    setOpenSnackbar(true);
                    setSnackbarSeverity('error'); // Set severity as error
                });
        }
        //  else {
        //     setSnackbarMessage("Please select a unit first.");
        //     setOpenSnackbar(true);
        //     setSnackbarSeverity('error');
        // }
    };
    const handleClearUnit2 = () => {
        setNewlyAddedUnitName(""); // Clear the newly added unit name
        // setNewUnitAdded(false); // Reset newUnitAdded state
    };


    const selectFields = [
        {
            name: "city",
            label: t.city,
            value: formik.values.city,
            options: lookups[1] || [],
            error: formik.errors.city,
            touched: formik.touched.city,
        },
        {
            name: "district",
            label: t.district,
            value: formik.values.district,
            options: formik.values.city ? (lookups[2] || []) : [],
            error: formik.errors.district,
            touched: formik.touched.district,
            message: formik.values.city ? "" : t.cityMessage,
        },
        {
            name: "project",
            label: t.project,
            value: formik.values.project,
            options: formik.values.district ? (lookups[3] || []) : [],
            error: formik.errors.project,
            touched: formik.touched.project,
            message: formik.values.district ? "" : t.districtMessage,
        },
        {
            name: "building",
            label: t.building,
            value: formik.values.building,
            options: formik.values.project ? (lookups[4] || []) : [],
            error: formik.errors.building,
            touched: formik.touched.building,
            message: formik.values.project ? "" : t.projectMessage,
        },
        {
            name: "floor",
            label: t.floor,
            value: formik.values.floor,
            options: formik.values.building ? (lookups[5] || []) : [],
            error: formik.errors.floor,
            touched: formik.touched.floor,
            message: formik.values.building ? "" : t.buildingMessage,
        },
        {
            name: "unit",
            label: t.unit,
            value: formik.values.unit,
            options: formik.values.floor ? (lookups[6] || []) : [],
            error: formik.errors.unit,
            touched: formik.touched.unit,
            message: formik.values.floor ? "" : t.floorMessage,
            disabled: newUnitAdded || newlyAddedUnitName
            // disabled: newUnitAdded || !formik.values.floor
        },
    ];
    if (!isLoggedIn) {
        navigate('/signin');
        return null;
    }
    return (
        <>
            <Box sx={{ border: "1px solid #CED4DA", backgroundColor: "#FFFFFF", borderRadius: "12px", padding: "24px" }}>
                {pendingUnitRequest ? ( // Show loading spinner if data is being fetched
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: 2,
                            padding: 2,
                        }}
                    >
                        <CircularProgress /> {/* Loading spinner */}
                    </Box>
                ) : pendingUnits.length > 0 ? ( // Show pending unit message if there are pending units
                    <Box
                        sx={{
                            marginBottom: 2,
                            padding: 2,
                            backgroundColor: "rgba(255, 0, 0, 0.1)",
                            border: "1px solid red",
                            borderRadius: 4,
                        }}
                    >
                        <p>
                            <strong>{pendingUnits[pendingUnits.length - 1].equipmentName}</strong>{" "}
                           {t.pendingMessage}
                        </p>
                    </Box>
                ) : null} {/* Render nothing if there are no pending units and loading is false */}

                <Box sx={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>

                    {selectFields.map((field, index) => (
                        <SelectDropdown
                            disabled={field.disabled}
                            key={index}
                            name={field.name}
                            label={field.label}
                            value={field.value}
                            onChange={formik.handleChange}
                            onClear={field.name === "unit" ? handleClearUnit : undefined}
                            onBlur={formik.handleBlur}
                            options={field.options.length > 0 ? field.options : []}
                            error={field.error}
                            touched={field.touched}
                            required
                            helperText={field.message}
                            t={t}
                            direction={direction}
                            sx={{ flex: "1 1 48%" }}
                        />
                    ))}
                </Box>
                {/* Button to open the Unit modal or perform any other action */}
                {newlyAddedUnitName ? (
                    <>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                p: 1,
                                mb: 2,
                                mt: 2,
                                border: "1px solid #ccc",
                                borderRadius: "8px",
                                backgroundColor: "#fff",
                            }}
                        >
                            <span>{newlyAddedUnitName.equipmentNameEn}</span> {/* Display the newly added unit's name */}
                            <IconButton onClick={handleClearUnit2} color="gray">
                                <FaTimes />
                            </IconButton>
                        </Box>
                    </>
                ) : (

                    <ActionButton
                        onClick={handleOpenUnit}
                        label={t.addNewUnit}
                        color="var(--custom-gold)"
                        hovercolor="var(--custom-gold-dark)"
                        icon={<FaPlus style={{ marginRight: "4px" }} />}
                        aria-label="Add New Unit"
                        sx={{ mb: 2 }}
                        disabled={formik.values.unit !== "" || formik.values.floor === "" || isAddDisabled}
                    />

                )}

                <UnitFormModal
                    open={openModal}
                    handleClose={handleCloseUnit}
                    title={t.addNewUnit}
                    handleFormSubmit={handleFormSubmit}
                    formik={formik}
                    t={t}
                />
                {/* Button to request a new unit */}

                <SuccessSnackbar
                    open={openSnackbar}
                    message={snackbarMessage}
                    onClose={() => setOpenSnackbar(false)}
                    severity={snackbarSeverity}
                />

            </Box>
            <Box sx={{ gap: "32px", display: "flex", justifyContent: "center", marginTop: "16px", flexDirection: { xs: "column", md: "row" } }}>
                <ActionButton
                    onClick={handleBack}
                    label={t.back} color="var(--back-color)" />
                <ActionButton
                    onClick={handleRequestNewUnit}
                    label={t.requestNewUnit}
                    color="var(--primary-color)"
                    hovercolor="var(--primary-color-dark)"
                    disabled={!(formik.values.unit || newlyAddedUnitName) || !formik.isValid || isAddDisabled}

                />
            </Box></>
    );
};

export default AddUnit;
